import React from 'react';

export const Loading = props => (
	<div className={"loading"}>
		<span />
		<span />
		<span />
		<span />
		<span />
		<span />
		<span />
		<span />
		<span />
		<span />
	</div>
);
